import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule, MatEndDate, MatStartDate } from '@angular/material/datepicker';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'formly-date-range-type',
    template: `
		<mat-date-range-input [formGroup]="formControl" [rangePicker]="picker" [formlyAttributes]="field">
			<input matStartDate #start placeholder="From" [required]="to.required" [readonly]="to.readonly" (dateChange)="onDateChange()" />
			<input matEndDate #end placeholder="To" [required]="to.required" [readonly]="to.readonly" (dateChange)="onDateChange()" />
		</mat-date-range-input>
		<ng-template #matSuffix>
			<mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
		</ng-template>
		<mat-date-range-picker #picker panelClass="linq-date-picker"></mat-date-range-picker>
	`,
    standalone: true,
    imports: [
        MatDatepickerModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
    ],
})
export class FormlyDateRangeTypeComponent extends FieldType<FormlyFieldConfig> implements AfterViewInit, OnDestroy {
	@ViewChild(MatStartDate) start: MatStartDate<any>;
	@ViewChild(MatEndDate) end: MatEndDate<any>;
	private readonly destroy$ = new Subject();

	ngAfterViewInit(): void {
		if (this.formControl?.value) {
			this.start.value = this.formControl.value.start;
			this.end.value = this.formControl.value.end;
		}

		this.formControl?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
			this.start.value = value?.start;
			this.end.value = value?.end;
		});
	}

	onDateChange(): void {
		if (this.start.value && this.end.value && this.start.value > this.end.value) {
			this.end.value = null;
		}
		this.value = { start: this.start.value, end: this.end.value };
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
		this.destroy$.next(undefined);
		this.destroy$.complete();
	}
}
